import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class ProductInventory extends Component {
  #section;
  #selectionVersion = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section?.addEventListener('change', this.#handleVariantChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#selectionVersion += 1;
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section?.removeEventListener('change', this.#handleVariantChange);
  }

  #handleVariantChange = (event) => {
    const target = event.target;
    if (!(target instanceof Element) || target.closest('product-card')) return;
    const picker = target.closest('variant-picker');
    if (!picker || picker.dataset.productId !== this.dataset.productId) return;
    const selected = target instanceof HTMLSelectElement ? target.selectedOptions[0] : target;
    const variantId = selected?.dataset.variantId;
    if (!variantId) return;
    const template = Array.from(this.querySelectorAll('template[data-isark-edition-variant]'))
      .find((item) => item.dataset.isarkEditionVariant === variantId);
    const line = this.querySelector('.isark-variant-edition__value');
    if (!template || !line) return;
    const text = template.content.textContent.trim();
    line.replaceChildren(template.content.cloneNode(true));
    line.hidden = !text;
  };

  /**
   * Handles product select event by updating the inventory.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const selectionVersion = ++this.#selectionVersion;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html || selectionVersion !== this.#selectionVersion || !this.isConnected) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newInventory = html.querySelector('product-inventory');
        if (!newInventory) return;

        morph(this, newInventory, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-inventory] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
